export enum GameStatus {
  Waiting = 'waiting',
  Ready = 'ready',
  InProgress = 'inprogress',
  Complete = 'complete'
}
